var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  position: relative;\n  line-height: 1.625;\n  margin-bottom: 0.4rem;\n  &:first-child {\n    padding-top: 0.4rem;\n  }\n\n  .indent p.no-errors {\n    display: none;\n  }\n\n  .radio {\n    display: inline-block;\n    cursor: pointer;\n  }\n\n  .radio:hover .inner {\n    transform: scale(0.5);\n    opacity: .5;\n  }\n\n  .radio input:checked + .outer {\n    border: ', ' solid ', ';\n  }\n\n  .radio input {\n    width: 1px;\n    height: 1px;\n    opacity: 0;\n    display: none;\n  }\n\n  .radio input:checked + .outer .inner {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  .radio input:focus + .outer .inner {\n    transform: scale(1);\n    opacity: 1;\n    background-color: ', ';\n  }\n\n  .radio .outer {\n    width: 17px;\n    height: 17px;\n    display: block;\n    float: left;\n    margin: 5px 7px 0px 0px;\n    border: ', ' solid #aaa;\n    border-radius: 50%;\n    background-color: #fff;\n  }\n\n  .radio .inner {\n    transition: all 0.25s ease-in-out;\n    width: 11px;\n    height: 11px;\n    transform: scale(0);\n    display: block;\n    margin: 2px 2px 0px 2px;\n    border-radius: 50%;\n    background-color: ', ';\n    opacity: 0;\n  }\n'], ['\n  display: flex;\n  position: relative;\n  line-height: 1.625;\n  margin-bottom: 0.4rem;\n  &:first-child {\n    padding-top: 0.4rem;\n  }\n\n  .indent p.no-errors {\n    display: none;\n  }\n\n  .radio {\n    display: inline-block;\n    cursor: pointer;\n  }\n\n  .radio:hover .inner {\n    transform: scale(0.5);\n    opacity: .5;\n  }\n\n  .radio input:checked + .outer {\n    border: ', ' solid ', ';\n  }\n\n  .radio input {\n    width: 1px;\n    height: 1px;\n    opacity: 0;\n    display: none;\n  }\n\n  .radio input:checked + .outer .inner {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  .radio input:focus + .outer .inner {\n    transform: scale(1);\n    opacity: 1;\n    background-color: ', ';\n  }\n\n  .radio .outer {\n    width: 17px;\n    height: 17px;\n    display: block;\n    float: left;\n    margin: 5px 7px 0px 0px;\n    border: ', ' solid #aaa;\n    border-radius: 50%;\n    background-color: #fff;\n  }\n\n  .radio .inner {\n    transition: all 0.25s ease-in-out;\n    width: 11px;\n    height: 11px;\n    transform: scale(0);\n    display: block;\n    margin: 2px 2px 0px 2px;\n    border-radius: 50%;\n    background-color: ', ';\n    opacity: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  margin-left: 0px;\n  max-width: 600px;\n  line-height: 1.5625rem;\n  font-weight: normal;\n'], ['\n  display: inline-block;\n  margin-left: 0px;\n  max-width: 600px;\n  line-height: 1.5625rem;\n  font-weight: normal;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  label {\n    font-weight: normal;\n  }\n'], ['\n  display: flex;\n  label {\n    font-weight: normal;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-top: 0px;\n  margin-bottom: 0px;\n  label {\n    margin: 0;\n    font-weight: normal;\n  }\n  .indent {\n    * > p.no-errors {\n      display: none;\n    }\n    ', ' > div {\n      margin-bottom: 0px;\n    }\n  }\n'], ['\n  margin-top: 0px;\n  margin-bottom: 0px;\n  label {\n    margin: 0;\n    font-weight: normal;\n  }\n  .indent {\n    * > p.no-errors {\n      display: none;\n    }\n    ', ' > div {\n      margin-bottom: 0px;\n    }\n  }\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var StyledRadioContainer = styled.div(_templateObject, function (props) {
  return props.theme.border_width;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.border_width;
}, function (props) {
  return props.theme.colours.primary.base;
});
var Label = styled.span(_templateObject2);
var FlexContainer = styled.div(_templateObject3);

var Radio = function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        checked = _props.checked,
        label = _props.label,
        id = _props.id,
        value = _props.value,
        onChange = _props.onChange,
        rest = _objectWithoutProperties(_props, ['checked', 'label', 'id', 'value', 'onChange']);

    var elementId = id || label;
    var elementValue = value || label;

    var change = function change(e) {
      onChange(elementValue);
    };

    return React.createElement(StyledRadioContainer, null, React.createElement('label', {
      className: 'radio',
      htmlFor: elementId
    }, React.createElement(FlexContainer, null, React.createElement('input', _extends({
      type: 'radio',
      id: elementId,
      name: elementId,
      value: elementValue,
      checked: checked
    }, rest, {
      'aria-label': label,
      onChange: change
    })), React.createElement('span', {
      className: 'outer'
    }, React.createElement('span', {
      className: 'inner'
    })), React.createElement(Label, null, label))));
  };

  return Radio;
}(React.Component);

export { Radio as default };
var RadioContainer = styled.div(_templateObject4, RadioContainer);
export var Radios = function (_React$Component2) {
  _inherits(Radios, _React$Component2);

  function Radios() {
    _classCallCheck(this, Radios);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Radios.prototype.render = function render() {
    var children = this.props.children;
    return React.createElement(RadioContainer, null, children);
  };

  return Radios;
}(React.Component);